import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import I18n from 'I18n';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const FromEmailOption = props => {
  const {
      children,
      option: {
        disabled
      }
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      disabled: !disabled,
      title: I18n.text('composer-ui.metadata-editor.from-email-option.tooltip-title'),
      children: children
    })
  }));
};
FromEmailOption.displayName = 'FromEmailOption';
export default FromEmailOption;